<!-- 自主报考预约时间，考场页面 -->
<template>
  <div class="content">
    <van-form @submit="gotoNext">
      <van-steps :active="active" active-icon="success" active-color="#38f">
        <van-step>预约时间</van-step>
        <van-step>个人信息</van-step>
        <van-step>上传文件</van-step>
      </van-steps>
      <!-- 预约课目 -->
      <h4>预约科目</h4>
      <van-field :rules="makeTestRules">
        <template #input>
          <van-checkbox-group
            :disabled="isRejected"
            v-model="selectedSubject"
            direction="horizontal"
          >
            <div class="appoint-title">预约考试等级<span>*</span></div>
            <!-- 等级 -->
            <div class="Selects" @click="Showoccupation(isRejected)">
              <TestInput
                readonly
                :rtest="occupationnr"
                :placeholder="'请选择考试等级'"
                :rules="[{ required: true }]"
              ></TestInput>
            </div>
            <van-popup
              position="bottom"
              round
              :style="{ height: '50%' }"
              v-model="occupationstatus"
            >
              <van-picker
                show-toolbar
                :columns="occupation"
                @confirm="onOccupiton"
                class="location-picker"
                cancel-button-text="选择考试等级"
              />
            </van-popup>
            <template>
              <!-- 科目 -->
              <van-checkbox
                v-for="(item, index) in subjectList"
                :key="index"
                class="checkmargin"
                shape="square"
                :name="item"
              >
                {{ item.craft.subjectName }}
                <span style="color: rgb(213, 213, 213)"
                  >({{ item.price }})</span
                >
              </van-checkbox>
              <div v-if="infotestHint" class="warning-msg">
                当前等级暂无考试信息
              </div>
            </template>
          </van-checkbox-group>
        </template>
      </van-field>

      <!-- 理论地点 -->
      <template v-if="theoryState">
        <h4>预约理论考试</h4>
        <div class="subscribe_time">
          <div class="appoint-title">预约考试地点<span>*</span></div>
          <div class="Select" @click="ShowPlacePopup">
            <TestInput
              readonly
              :rtest="examaddress"
              :placeholder="'请选择考试地点'"
              :rules="[{ required: true }]"
            >
            </TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="PlaceShow"
          >
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="theoryPlaceConfirm"
              class="location-picker"
              cancel-button-text="选择考试地点"
            />
          </van-popup>

          <!-- 理论时间 -->
          <template>
            <div class="appoint-title">预约理论考试时间<span>*</span></div>
            <div class="Select" @click="ShowTimePopup">
              <TestInput
                readonly
                :rtest="examTime"
                :placeholder="'请选择理论考试时间'"
                :rules="[{ required: true }]"
              >
              </TestInput>
            </div>
            <van-popup
              position="bottom"
              round
              :style="{ height: '50%' }"
              v-model="TimeShow"
            >
              <div
                @click="theoryTimeConfirm"
                style="float: right; margin-top: 16px; margin-right: 20px"
                name="cross"
              >
                确定
              </div>
              <h4>选择考试时间</h4>
              <van-tree-select
                :items="theory.examTime"
                :active-id.sync="theoryActiveId"
                :main-active-index.sync="theoryActiveIndex"
                @click-item="selectTheoryTime"
                max="1"
              />
            </van-popup>
          </template>
        </div>
      </template>

      <!-- 实操地点 -->
      <template v-if="operationState">
        <h4>预约实操考试</h4>
        <div class="subscribe_time">
          <div class="appoint-title">预约考试地点<span>*</span></div>
          <div class="Select" @click="operationPopup">
            <TestInput
              readonly
              :rtest="liveAddress"
              :placeholder="'请选择考试地点'"
              :rules="[{ required: true }]"
            >
            </TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="liveAddressShow"
          >
            <van-picker
              show-toolbar
              :columns="columnlives"
              @confirm="fieldPlaceConfirm"
              class="location-picker"
              cancel-button-text="选择考试地点"
            />
          </van-popup>
          <!-- 实操时间 -->

          <template>
            <div class="appoint-title">预约实操考试时间<span>*</span></div>
            <div class="Select" @click="filedShowTimePopup">
              <TestInput
                readonly
                :rtest="filedDataText"
                :placeholder="'请选择实操考试时间'"
                :rules="[{ required: true }]"
              >
              </TestInput>
            </div>
            <van-popup
              position="bottom"
              round
              :style="{ height: '50%' }"
              v-model="filedTimeShow"
            >
              <div
                @click="fieldTimeConfirm"
                style="float: right; margin-top: 16px; margin-right: 20px"
                name="cross"
              >
                确定
              </div>
              <h4>选择考试时间</h4>
              <van-tree-select
                :items="field.examTime"
                :active-id.sync="fieldActiveId"
                :main-active-index.sync="fieldActiveIndex"
                @click-item="selectFiledTime"
                max="1"
              />
            </van-popup>
          </template>
        </div>
      </template>
      <div class="btn">
        <van-button block type="info" native-type="submit" :disabled="grayBtn"
          >下一步</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import Select from "@/components/Select";
import TestInput from "@/components/choosec";
import { showaddres } from "../../api/apitotal.js";
import { Dialog, Notify, Toast } from "vant";
export default {
  components: {
    Select,
    TestInput,
  },
  data() {
    return {
      subjectList: [], //科目容器
      examaddress: "", //理论考试地点input
      liveAddress: "", //实操考试地点input
      occupationnr: "", //考试等级input
      selectedSubject: [], //复选框组勾选状态
      theoryState: false, //监听理论
      operationState: false, //监听实操
      theoryActiveIndex: 0, //理论左侧选中项的索引
      fieldActiveIndex: 0, //实操的左侧选中项的索引
      theoryActiveId: 0, //理论右侧选中的时间
      fieldActiveId: 0, //实操右侧选中的时间
      theoryData: {}, //理论时间数据
      filedData: {}, //实操时间数据
      disabled: false,
      active: 0, //步骤条索引
      TimeShow: false, //理论时间的弹出层开关
      filedTimeShow: false, //实操时间弹出层开关
      PlaceShow: false, //理论地点弹出层开关
      liveAddressShow: false, //实操地点弹出层开关
      columns: [], ////理论地点picker容器
      columnlives: [], //实操地点picker容器
      columnlive: [], //推送地址的空变量
      columnc: [], //推送地址的空变量
      infotestHint: false, //当前等级暂无考试
      signupDetails: {}, //接收数据容器
      occupationstatus: false, //科目弹出层开关
      occupation: [], //科目picker容器
      fieldExamTime: "",
      grayBtn: true, //下一步按钮  开关
      //预约课目的验证
      makeTestRules: [
        {
          //validator是函数验证
          validator: (value) => {
            if (value && value != "请选择考试等级") {
              return true;
            } else {
              return false;
            }
          },
          message: "请选择考试等级",
        },
      ],
      theory: {
        appraisalId: "",
        subjectName: "",
        addressId: "",
        examTime: [], //理论时间数组
      },
      field: {
        appraisalId: "",
        subjectName: "",
        addressId: "",
        examTime: [], //理论时间数组
      },
      filedDataText: "", //实操考试时间input
      examTime: "", //理论考试时间input
      craftStatus: true,
    };
  },
  computed: {
    examIds: function () {
      let arr = this.selectedSubject.map((item) => item.examId).join(",");
      return arr;
    },
    isRejected: function () {
      return this.$route.query.status === "rejected";
    },
    //去重
    isSelectTheory: function () {
      return this.selectedSubject.some((ele) => ele.subjectName === "理论");
    },
    //去重
    isSelectField: function () {
      return this.selectedSubject.some((ele) => ele.subjectName === "实操");
    },
  },
  watch: {
    active: function () {
      this.craftStatus = true;
    },
    //监听勾选科目
    selectedSubject: {
      handler(newValue, oldValue) {
        this.theoryState = false;
        this.operationState = false;
        if (this.subjectList.length > 0) {
          console.log(this.subjectList);
          this.selectedSubject.forEach((item) => {
            console.log(item);

            if (item.subjectName == "理论") {
              console.log(777777777);
              this.theoryState = true;
              this.theory.appraisalId = item.courses[0].id;
              this.theory.addressId = this.signupDetails.examAddressId;
              this.theory.subjectName = "theory";
              if (item.subjectName == "理论" && oldValue.length === 0) {
                console.log("**********走到清除理论这了");
                this.examaddress = "";
                this.examTime = "";
              }
              //取消勾选就清空相应的input框
              console.log(item.courses[0].id);
              console.log(this.signupDetails.examAddressId);
            } else if (item.subjectName == "实操") {
              this.operationState = true;
              this.field.appraisalId = item.courses[0].id;
              this.field.addressId = this.signupDetails.liveAddressId;
              this.field.subjectName = "operation";
              if (item.subjectName == "实操" && oldValue.length === 0) {
                console.log("**********走到清除实操这了");
                this.liveAddress = "";
                this.filedDataText = "";
              }
              console.log(88888888, this.signupDetails);
            } else {
              console.log(9999999999);
              this.selectedSubject = [];
              this.operationState = false;
              this.theoryState = false;

              this.examaddress = "";
              this.examTime = "";
              this.liveAddress = "";
              this.filedDataText = "";
            }
          });
        }
        // if(!this.craftStatus){
        //   this.examaddress = ''
        //   this.examTime = ''
        //   this.liveAddress = ''
        //   this.filedDataText = ''
        // }
        console.log(newValue);
        console.log(oldValue);
        console.log("触发了watch的复选框了");
      },
      deep: true,
      // immediate: true,
    },
    // 监听实操时间input
    filedDataText: {
      handler() {
        if (this.filedDataText != "") {
          this.grayBtn = false;
          return false;
        }
        console.log("触发了watch的filedDataText了", this.filedDataText);
      },
      deep: true,
      // immediate: true
    },
    //监听理论时间input
    examTime: {
      handler() {
        if (this.examTime !== "") {
          this.grayBtn = false;
          return false;
        }
        console.log("触发了watch的examTime");
      },
      deep: true,
      // immediate: true
    },

    // 监听实操时间
    filedData: {
      handler() {
        if (this.filedData.day && this.filedData.period) {
          this.filedDataText =
            this.filedData.day + " " + this.filedData.period;
        }
      },
      deep: true,
      // immediate: true
    },
    // 监听理论时间
    theoryData: {
      handler() {
        if (this.theoryData.day && this.theoryData.period) {
          this.examTime =
            this.theoryData.day + " " + this.theoryData.period;
        }
        console.log("触发了watch的theoryData", this.examTime);
      },
      deep: true,
      immediate: true,
    },
    examIds: function (value) {
      console.log("89898989889", value);
      if (value) {
        this.fetchExamTime();
      }
      console.log("触发了watch的examIds了");
    },
    //监听考试等级input
    occupationnr: {
      handler(value) {
        if (value) {
          console.log("触发监听考试等级框");
          //这一步很重要  切换等级先清空勾选的数组
          this.selectedSubject = [];
          //切换等级把四个输入框都清空
          this.examaddress = "";
          this.examTime = "";
          this.liveAddress = "";
          this.filedDataText = "";

          console.log(this.selectedSubject);
          this.theoryState = false;
          this.operationState = false;
          this.subjectshow();
        }
        console.log("触发了watch的考试等级input框了");
      },
      deep: true,
      // immediate: true,
    },
    //监听理论地点
    examaddress: {
      handler(newValue, oldValue) {
        if (oldValue) {
          this.examTime = "";
          this.theoryActiveId = "";
        }
      },
    },
    //监听实操地点
    liveAddress: {
      handler(newValue, oldValue) {
        if (oldValue) {
          this.filedDataText = "";
          this.fieldActiveId = "";
        }
      },
    },
  },

  async created() {
    console.log("0输出"+ this.$route.query.examOrderId)
    if (this.$route.query.examOrderId != null && this.$route.query.examOrderId != undefined) {
      await this.fetchSignupDetails(this.$route.query.examOrderId);
      console.log(this.$route.query.examOrderId);
      console.log("1输出",this.$route.query.examOrderId)
    } else {
      console.log("2输出"+this.$route.query.examOrderId)
      this.$http.get("ExamOrder/findDraft").then((res) => {
        console.log(res.data)
        if (res.data.success && res.data.data.examOrderId != null) {
          localStorage.setItem("examOrderId", res.data.data.examOrderId);
          this.fetchSignupDetails(res.data.data.examOrderId);
          console.log("3输出"+res.data.data.examOrderId)

        }
      });
    }
    //考试等级
    this.fetchExamLevel();
    //考试地址
    this.showaddress();
    //请求时间
    this.fetchExamTime();
  },

  methods: {
    selectTheoryTime: function (value) {
      //选择的理论数据
      this.theoryData = value;
      console.log(value);
    },
    selectFiledTime: function (value) {
      console.log(value);
      //选择的实操数据
      this.filedData = value;
    },
    //请求考试信息
    fetchExamLevel: function () {
      const params = {
        ooccopationid: null,
      };
      this.$http.get("ExamAddress/FindListOccupation", params).then((res) => {
        if (res.status == 200) {
          if (res.data.length == 0) {
            this.$message({
              message: "暂无报考信息",
              type: "warning",
            });
          } else {
            this.occupation = res.data.data.levelDetails;
          }
        }
      });
    },
    //  请求赋值主要是查询草稿状态  给signupDetails赋值
    fetchSignupDetails: function (examOrderId) {
      var params = {
        examOrderId: examOrderId,
      };
      return new Promise((resolve) => {
        //查询状态用户数据
        this.$http.post(`ExamOrder/ExamOrderShowOne`, params).then((res) => {
          if (res.data.success && res.data.data.list != null) {
            this.signupDetails = res.data.data.list;
            this.occupationnr = this.signupDetails.examRank; //等级input
            // this.examaddress = this.signupDetails.examAddress; //理论考试地点input
            // this.liveAddress = this.signupDetails.liveAddress; //实操考试地点
            //this.theory.addressId = this.signupDetails.examAddressId; //理论考点id
            //this.field.addressId = this.signupDetails.liveAddressId; //实操考点ID
            resolve();
          }
        });
      });
    },
    // 请求时间的方法
    fetchExamTime: function (addressId, subjectName, appraisalId) {
      const params = {
        appraisalId: appraisalId,
        addressId: addressId,
        subject: subjectName,
      };
      this.$http.get("/registration/time", { params }).then((res) => {
        //TODO  理论
        if (res.data.success) {
          if (subjectName === "theory") {
            this.theory.examTime = res.data.data.timeList;
            this.theory.examTime.forEach((res) => {
              res.text = res.label;
              res.children.forEach((res1) => {
                res1.text = res1.period + ` 剩余${res1.remainNumber}人`;
                if (res1.remainNumber <= 0) {
                  res1.disabled = true;
                }
              });
            });
          }
          if (subjectName === "operation") {
            this.field.examTime = res.data.data.timeList;
            this.field.examTime.forEach((res) => {
              res.text = res.label;
              res.children.forEach((res1) => {
                res1.text = res1.period + ` 剩余${res1.remainNumber}人`;
                if (res1.remainNumber <= 0) {
                  res1.disabled = true;
                }
              });
            });
          }
        }
        //  实操的
      });
    },
    //下一步
    gotoNext: function () {
      if (this.selectedSubject.length == 0) {
        Toast({
          message: "请先选择科目！",
          position: "bottom",
        });
        return false;
      }
      const params1 = {
        list: JSON.stringify(this.selectedSubject),
        theScheduleId: this.theoryData.id,
        opeScheduleId: this.filedData.id,
        examOrderId: this.$route.query.examOrderId ||localStorage.getItem("examOrderId"),
        examAddress: this.examaddress,
        examAddressId: this.theory.addressId,
        liveAddressId: this.field.addressId,
        liveAddress: this.liveAddress,
      };
      console.log(params1.examOrderId)
      console.log(this.$route.query.examOrderId)
      console.log(localStorage.getItem("examOrderId"))
      //去重
      if (!this.isSelectTheory) {
        params1.examAddress = "";
        params1.examAddressId = "";
        params1.theScheduleId = "";
      }
      if (!this.isSelectField) {
        params1.liveAddress = "";
        params1.liveAddressId = "";
        params1.opeScheduleId = "";
      }
      this.$http.post(`ExamOrder/add`, params1).then((ress) => {
        localStorage.removeItem("examOrderId");
        if (ress.data.success) {
          this.$router.push({
            path: "/ownmessage",
            query: { examOrderId: ress.data.data.examOrderId },
          });
        } else {
          Dialog.alert({
            confirmButtonText: "确认",
            confirmButtonColor: "#54B0FB",
            title: "提示",
            message: ress.data.msg,
          }).then(() => {
            // on close
          });
        }
      });
    },
    //请求考试等级的方法
    subjectshow() {
      var applanId = null;
      if (this.$route.query.applanId != null) {
        applanId = this.$route.query.applanId;
      }
      if (
        this.$route.query.ExamOrder &&
        this.$route.query.ExamOrder.appraisalBatchId != null
      ) {
        applanId = this.$route.query.ExamOrder.appraisalBatchId;
      }
      if (this.signupDetails.appraisalBatchId) {
        applanId = this.signupDetails.appraisalBatchId;
      }
      const params = {
        occupationName: this.occupationnr,
      };
      //查询批次  也就是等级
      this.$http.get(`ExamAddress/ShowBatch`, { params }).then((dat) => {
        if (dat.status == 200) {
          const params1 = {
            appraisalBatchId: dat.data.data.occupationId,
          };
          //查询科目
          this.$http.post(`ExamAddress/ShowExam`, params1).then((dat) => {
            if (dat.status == 200) {
              let list = dat.data;
              if (list.length > 1 && list[0].subjectName === "实操") {
                this.subjectList = list.reverse();
              } else {
                this.subjectList = list;
              }
              if (this.subjectList.length > 0) {
                this.infotestHint = false;
                this.grayBtn = false;
              } else {
                this.infotestHint = true;
                this.grayBtn = true;
              }
              //解决第一次赋值   第二次还赋值的状况
              //  草稿科目赋值
              if (this.selectedSubject && this.craftStatus) {
                console.log("走到科目草稿状态了", this.subjectList);
                let selectSubject = this.signupDetails.subject.split("，");
                //  去除重复的科目
                selectSubject.forEach((ele) => {
                  console.log(
                    "subject:" +
                      ele +
                      " of index of list:" +
                      this.subjectList.indexOf(ele)
                  );
                  let findResult1 = this.subjectList.filter(
                    (ele1) => ele1.subjectName === ele
                  );
                  let findResult2 = this.selectedSubject.filter(
                    (ele1) => ele1.subjectName === ele
                  );
                  if (findResult1.length > 0 && findResult2.length == 0) {
                    this.selectedSubject.push(findResult1[0]);
                  }
                });
                console.log(this.selectedSubject);
              }
              //  草稿理论赋值
              if (
                this.selectedSubject[0].subjectName == "理论" &&
                this.selectedSubject.length === 1
              ) {
                console.log("走到理论草稿状态了", this.signupDetails);
                this.theoryState = true;
                this.theoryActiveId =
                  this.signupDetails.examTime.children[0].id;
                this.theory.appraisalId = this.signupDetails.courses[0].id; //批次id
                this.theory.subjectName = "theory";
                this.theory.addressId = this.signupDetails.examAddressId; //理论考点id
                this.fetchExamTime(
                  this.theory.addressId,
                  this.theory.subjectName,
                  this.theory.appraisalId
                );
                this.examaddress = this.signupDetails.examAddress; //理论考试地点
                this.theoryData = this.signupDetails.examTime.children[0];
              } else if (
                this.selectedSubject[0].subjectName == "实操" &&
                this.selectedSubject.length === 1
              ) {
                //  草稿实操赋值
                console.log("走到实操草稿状态了", this.signupDetails);
                this.operationState = true;
                this.fieldActiveId = this.signupDetails.liveTime.children[0].id;
                this.field.appraisalId = this.signupDetails.courses[0].id; //批次id
                this.field.subjectName = "operation";
                this.field.addressId = this.signupDetails.liveAddressId;
                console.log(this.signupDetails);
                this.fetchExamTime(
                  this.field.addressId,
                  this.field.subjectName,
                  this.field.appraisalId
                );

                this.liveAddress = this.signupDetails.liveAddress;
                console.log(this.signupDetails);
                console.log(this.signupDetails.liveAddress);
                //显示的时间input
                this.filedData = this.signupDetails.liveTime.children[0];
              } else {
                //理论+实操
                console.log("走到第三种情况了", this.signupDetails);
                this.theoryState = true;
                this.operationState = true;
                
                this.theoryActiveId = this.signupDetails.examTime.children[0].id;
                this.fieldActiveId = this.signupDetails.liveTime.children[0].id;

                this.theory.appraisalId = this.signupDetails.courses[0].id; //批次id
                this.theory.subjectName = "theory";
                this.theory.addressId = this.signupDetails.examAddressId; //理论考点id
                this.examaddress = this.signupDetails.examAddress; //理论考试地点

                this.field.appraisalId = this.signupDetails.courses[0].id; //批次id
                this.field.subjectName = "operation";
                this.field.addressId = this.signupDetails.liveAddressId;
                this.liveAddress = this.signupDetails.liveAddress; //实操考试地点

                console.log(this.signupDetails);
                this.fetchExamTime(
                  this.theory.addressId,
                  this.theory.subjectName,
                  this.theory.appraisalId
                );
                this.fetchExamTime(
                  this.field.addressId,
                  this.field.subjectName,
                  this.field.appraisalId
                );
                this.theoryData = this.signupDetails.examTime.children[0];
                this.filedData = this.signupDetails.liveTime.children[0];
              }
              this.craftStatus = false;
              // }
            }
          });
        }
      });
      // 考试科目
    },
    // 考试地址
    showaddress() {
      this.$http.get("ExamAddress/ShowAll").then((res) => {
        if (res.data.success && res.status == 200) {
          this.columnc = res.data.data.list;
          this.columnlive = res.data.data.list;
          this.columnlive.forEach((element) => {
            console.log(element);
            this.columnlives.push(element.examAddressName);
          });
          this.columnc.forEach((element) => {
            this.columns.push(element.examAddressName);
          });
        }
      });
    },
    //预约考试等级
    Showoccupation(isRejectedFlag) {
      if (isRejectedFlag) return false;
      this.occupationstatus = true;
    },
    //理论地点popup
    ShowPlacePopup() {
      if (this.subjectList.length > 0) {
        this.PlaceShow = true;
      } else {
        this.PlaceShow = false;
      }
    },
    //实操地点popup
    operationPopup() {
      if (this.subjectList.length > 0) {
        this.liveAddressShow = true;
      } else {
        this.liveAddressShow = false;
      }
    },
    //理论时间确定按钮
    ShowTimePopup() {
      if (this.subjectList.length > 0) {
        this.TimeShow = true;
      } else {
        this.TimeShow = false;
      }
    },
    //实操时间确定按钮
    filedShowTimePopup() {
      if (this.subjectList.length > 0) {
        this.filedTimeShow = true;
      } else {
        this.filedTimeShow = false;
      }
    },
    //考试等级picker确定按钮
    onOccupiton(value, index) {
      this.occupationnr = value;
      this.occupationstatus = false;
    },
    //理论地点确定按钮
    theoryPlaceConfirm(value, index) {
      this.examaddress = value;
      this.theory.addressId = this.columnc[index].id;
      this.fetchExamTime(
        this.theory.addressId,
        this.theory.subjectName,
        this.theory.appraisalId
      );
      this.PlaceShow = false;
    },
    //理论时间确定按钮
    theoryTimeConfirm(value, index) {
      this.TimeShow = false;
    },
    //实操地点确定按钮
    fieldPlaceConfirm(value, index) {
      console.log(value);
      this.liveAddress = value;
      this.field.addressId = this.columnlive[index].id;
      console.log(this.columnc);
      console.log(this.field.addressId);
      this.fetchExamTime(
        this.field.addressId,
        this.field.subjectName,
        this.field.appraisalId
      );
      this.liveAddressShow = false;
    },
    //实操时间确定按钮
    fieldTimeConfirm(picker, value, index) {
      this.filedTimeShow = false;
    },
  },
};
</script>
 
<style scoped lang="less">
.checkmargin {
  padding: 18px;
  background: @whitee;
}
.checkmargin:last-child {
  padding-bottom: @padingboxmax;
}
.content {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: @whitee;
}
.rightcha {
  float: left;
}
.rightcha img {
  vertical-align: middle;
}
#top {
  width: 100%;
  height: 70px;
  line-height: 70px;
  vertical-align: middle;
  background-color: rgba(245, 245, 245);
}
.subscribe {
  background-color: #fff;
  width: 100%;
  height: 250px;
}
.subscribe_time {
  padding: 30px;
  background-color: #fff;
}
::v-deep .van-radio {
  margin-bottom: 35px;
}
.Select {
  width: 100%;
  height: @minboxgao;
  margin: @padingboxmax 0;
  line-height: @minboxgao;
}
.Selects {
  width: 690px;
  height: @minboxgao;
  margin: @padingboxmax 0;
  line-height: @minboxgao;
}

.choose1_text {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 12px 0;
}
.choose1_textt {
  display: inline-block;
  width: 175px;
}
.choose1_check {
  width: 25px;
  height: 25px;
}
h4 {
  height: @minboxgao;
  padding: 0 @padingbox;
  line-height: @minboxgao;
  background: @backgroundcolor;
}
.appoint-title {
  height: @textgao;
  line-height: @textgao;
  margin-top: 18px;
  span {
    color: red;
  }
}
.btnbox {
  // position: absolute;
  padding: 38px;
  margin: 0 auto;
  width: 93%;
  box-sizing: border-box;
  background: @whitee;
  // bottom: 0;
}
.btnbox_next {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 20px 30px;
}
#top {
  text-align: center;
  height: 176px;
  box-sizing: border-box;
  padding-top: 125px;
  background-color: @backgroundcolor;
  padding-bottom: 69px;
}
.location-picker .van-picker__toolbar {
  padding: 4px;
}

.location-picker .van-picker__cancel {
  font-weight: bold;
  font-size: 16px;
  color: white;
}
.van-checkbox-group {
  flex-direction: column;
}
.ceshi {
  border: 1px solid #dcdcdc;
  width: 690px;
  height: 90px;
  margin: 24px 29px;
  border-radius: 10px;
}
.btn {
  // width: 100%;
  // position: fixed;
  bottom: 20px;
  margin-left: 30px;
  width: 690px;
  height: 90px;
  background: #54b0fb;
  border-radius: 8px;
}
.warning-msg {
  color: red;
}
</style>